import React from 'react'
import '../main.css';
const Loading = () => {
  return (
    <div className='loading-text'>{JSON.parse(localStorage.getItem('brand')).logo}</div>
  )
}

export default Loading